import { Link } from 'react-router';

import { Button } from '@mantine/core';
import { PageContainer } from '@shared/ui';
import { IconPlus } from '@tabler/icons-react';
import classes from './vacancies-templates-list-page.module.scss';
import {
  VacanciesTemplatesBreadcrumbs,
  VacanciesTemplatesList,
} from '@features/vacanciesTemplates';
import { useEffect } from 'react';
import { useBreadcrumbs } from '@shared/lib';

export const VacanciesTemplatesListPage = () => {
  const context = useBreadcrumbs();

  useEffect(() => {
    if (!context) {
      return;
    }

    context.setBreadcrumb(
      <VacanciesTemplatesBreadcrumbs
        withListLink={false}
        subPage='Шаблоны вакансий'
      />
    );

    return () => {
      context.clearBreadcrumb();
    };
  }, []);

  return (
    <PageContainer
      title='Шаблоны вакансий'
      actionButton={
        <Button
          component={Link}
          to='/vacancies-templates-list/create'
          leftSection={<IconPlus />}
          className={classes.addTemplateButton}
          size='md'
        >
          Создать шаблон
        </Button>
      }
    >
      <VacanciesTemplatesList />
    </PageContainer>
  );
};
